import React from 'react';
import Header from './components/Header';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import About from './components/About';
import Footer from './components/Footer';
import ContactForm from './components/ContactForm';

function App() {
  return (
    <div className="App">
      <Header />
      <Services />
      <Testimonials />
      <ContactForm/>
      <About />
      <Footer />
    </div>
  );
}

export default App;